import { AnalyticsEventType } from '@/services/analytics/platforms/adobe-analytics/models';
import { CarouselClickEvent } from '@/services/analytics/events';
import { AdobeBaseEvent } from './adobe-base-event';
import { Store } from 'vuex';
import { AppState } from '@/store';
import { ServicesContainer } from '@/services';

export class AdobeCarouselClickEvent extends AdobeBaseEvent {
  name = 'AdobeCarouselClickEvent';
  event = AnalyticsEventType.LinkClicked;

  constructor(event: CarouselClickEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);
    this.web.webInteraction = {
        linkClicks: { value: 1 },
        name: 'carousel',
        type: 'other',
        linkModuleName: `featured-meals|${event.type}|${event.mealName}`,

        carouselClicks: { value: 1 },
        carouselNameInteraction: `featured-meals|${event.type}|${event.mealName}`,
    }
  }
}